// extracted by mini-css-extract-plugin
module.exports = {"moreResults":"moreResults_3GbiK","moreResultsButton":"moreResultsButton_3TFtd","moreResultsArrow":"moreResultsArrow_lzAFP"};